/** Maps practice-dashboard tab ids to EventLogSection moduleId values. */
export const PRACTICE_TAB_EVENT_LOG_MODULE = {
  admin: 'Admin',
  provider: 'Provider',
  caregiver: 'Caregiver',
  patient: 'Patient',
  'system-caregiver': 'System Caregiver',
  rpm: 'RPM',
  import: 'Import',
  dashboard: 'Practice',
};

export const PRACTICE_EVENT_LOGS_QUERY = 'eventLogs';

export const isPracticeEventLogsActive = (searchParams, tabId = null) => {
  const active = searchParams?.get(PRACTICE_EVENT_LOGS_QUERY) === '1';
  if (!active || !tabId) return active;
  return active;
};

export const getPracticeTabEventLogModule = (tabId) =>
  PRACTICE_TAB_EVENT_LOG_MODULE[tabId] || null;

export const supportsPracticeInlineEventLogs = (tabId) =>
  Boolean(getPracticeTabEventLogModule(tabId));
